export default __webpack_public_path__ + "static/media/ic_secure.189a58b5.png";